import { IxSecondaryTab } from './IxSecondaryTab.js';

window.customElements.define('ix-secondary-tab', IxSecondaryTab);
